const base = 'GlobalLists';

const AchievementKeys = {
  globalLists: `${base}`,
  Achievements: `${base}/Achievements`,
};

export default AchievementKeys;
